import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import MainRouting from '../routes/mainRouting';
import { useSelector } from 'react-redux';
import { RootState } from '../store/reducers';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { getEstruturaLevelDisciplinas } from '../store/actions/estruturaDiscActions';
import { useGetProfile } from '../store/actions/AuthAction';
import { log } from '../utils/log';
import { hasNoSystemAccess } from '../utils/permissions';
import { useEduCapabilities } from '../features/fermiEdu/capabilities';
import { canOpenEduAdministration } from '../features/fermiEdu/policies';
import { isEduPath } from '../features/fermiEdu/navigation';
import CircularProgress from '@mui/material/CircularProgress';

interface iAppBaseMobile {}

const AppBaseMobile = (props: iAppBaseMobile) => {
    const isAuthenticatedold = useSelector(
        (state: RootState) =>
            state.auth.id !== null && state.auth.expiresIn * 1000 > new Date().getTime()
    );
    const isAuthenticated = useSelector(
        (state: RootState) => state.auth.id !== null && typeof state.auth.id !== 'undefined'
    );
    const auth = useSelector((state: RootState) => state.auth);
    const { error } = useGetProfile();
    const { capabilities, ready } = useEduCapabilities(); const location = useLocation();
    let navigate = useNavigate();

    useEffect(() => {
        if (error) {
            log(2, 'AppBase.js error=true');
            navigate('/login');
        }
    }, [error]);

    log(3, 'AppBase.rendering...');

    if (!isAuthenticated) {
        log(2, 'AppBase nao autenticado');
        return <Navigate replace to="/login" />;
    } else if (auth.roleLoaded && hasNoSystemAccess(auth.roleName)) {
        if (!ready) return <CircularProgress size={28} />;
        if (!canOpenEduAdministration(capabilities)) return <Navigate replace to="/login" />;
        if (!isEduPath(location.pathname)) return <Navigate replace to="/mob/fermi-edu" />;
    } else {
        log(2, 'AppBaseMobile autenticado!');
    }

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100vh',
                bgcolor: 'background.default',
            }}
        >
            <TopBar isAuthenticated={isAuthenticated} auth={auth} />
            <Sidebar isAuthenticated={isAuthenticated} auth={auth} roleName={auth.roleName} />
            <Box
                component="main"
                id="mainAppContainer"
                sx={{
                    flexGrow: 1,
                    pt: '56px',
                    minHeight: '100vh',
                    overflow: 'auto',
                    transition: 'margin-left 0.28s ease',
                }}
            >
                <Box sx={{ p: { xs: 1, sm: 1.5 }, minHeight: 'calc(100vh - 56px)' }}>
                    <MainRouting />
                </Box>
            </Box>
        </Box>
    );
};

export default AppBaseMobile;
